import { render, staticRenderFns } from "./ywb-fw.vue?vue&type=template&id=36b3ccce"
import script from "./ywb-fw.vue?vue&type=script&lang=js"
export * from "./ywb-fw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports